<app-dpr-comment [maxLength]="maxLength" [comment]="comment" [canEdit]="canEdit"></app-dpr-comment>
<div class="border-top"></div>
<app-dpr-attachments
  [gridData]="gridData"
  [namingConvention]="selectedSubproject?.data?.namingConvention"
  [identifier]="'current'"
  [canEdit]="canEdit"
  [clientId]="clientId"
  [isAppOnline]="isAppOnline"
  [fileUploadConfig]="fileUploadConfig"
  [predefinedChanges]="predefinedChanges"
  [shouldDisplayPrintInReport]="shouldDisplayPrintInReport"
  (gridRegistered)="onGridRegistered($event)"
  (dataChanged)="onAttachmentsChanged()"
></app-dpr-attachments>
